// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/tooltip/style/index.less
// module id = 960
// module chunks = 1